export enum OptionsListEnum {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
}

export enum RangeListEnum {
  D1 = '1D',
  D5 = '5D',
  M1 = '1M',
  M3 = '3M',
  M6 = '6M',
  Y1 = '1Y',
  Y2 = '2Y',
  Y3 = '3Y',
  ALL = 'ALL',
}
